import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#34C94B',
      dark:'#121212',
  
    },
    secondary: {
     
      main:'#ffffff'
     
  },

}
});
export default theme;
